import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-shell',
    imports: [RouterModule],
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss']
})
export class ShellComponent {
  constructor() { }

}
